import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = `${environment.apiBaseUrl}/authR`;

  private tokenKey = 'token';
  private userKey = 'user';
  public Token: string | null = null;

  constructor(private http: HttpClient, private router: Router) { }

  login(loginId: string, password: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json' , "authfor": "W"
    });
    const body = {
      criteria: {
        "loginId": loginId,
        "password": password
      }
    };
    return this.http.post(`${this.apiUrl}/login`, body, { headers });
  }

  saveToken(token: string) {
    localStorage.setItem('token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  saveUser(user: any) {
    localStorage.setItem(this.userKey, JSON.stringify(user));
  }

  getUser() {
    return JSON.parse(localStorage.getItem(this.userKey) || '{}');
  }

  logout() {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
    this.router.navigate(['/login']);
  }

}
